import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateSessionGuard implements CanActivate {
  private static allowAccess = false;

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const navigation = this.router.getCurrentNavigation();
    const extrasState = navigation && navigation.extras && navigation.extras.state ? navigation.extras.state as { type?: string} : null;
    const token = StorageService.checkStorage().getItem('_token');
    const email = StorageService.checkStorage().getItem('_email');
    if (ValidateSessionGuard.allowAccess && ( (token && email) || (extrasState && extrasState.type === 'logout'))) {
      ValidateSessionGuard.allowAccess = false;
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }

  // Método estático para habilitar el acceso desde el cross-tab sync
  static enableAccess(): void {
    ValidateSessionGuard.allowAccess = true;
  }
}
